<template>
	<el-container>
		<!--弹出框界面-->
		<!--密码重设-->
		<el-dialog title="修改密码" :visible.sync="passwordChangeVisible">
		  	<el-form  label-width="110px" >
		  		<el-form-item label="输入原有密码" >
					<el-input v-model="password.passwordOld" ></el-input>
				</el-form-item>
				<el-form-item label="输入新密码" >
					<el-input v-model="password.passwordNew" ></el-input>
				</el-form-item>
			</el-form>
		<div slot="footer" class="dialog-footer">
		    <el-button @click="passwordChangeVisible = false">取 消</el-button>
		    <el-button type="primary" @click="passwordChange" :loading="addLoading">确 定</el-button>
		</div>
		</el-dialog>
		<el-dialog title='公司详情设置' :visible.sync="organDetailVisible">
			<el-row :gutter="20">
			  	<el-col :span="6">
			  		<div class="grid-content bg-purple">全称<el-input v-model="organDetail.name"></el-input></div>
			  		<div class="grid-content bg-purple">简称<el-input v-model="organDetail.shortname"></el-input></div>
			  		<div class="grid-content bg-purple">联系电话<el-input v-model="organDetail.organ_phone"></el-input></div>
			  	</el-col>
			  	<el-col :span="6">
			  		<div class="grid-content bg-purple">头像设置</div>
			  		<div class="grid-content bg-purple">
			  			<el-upload
						  class="avatar-uploader headimage"
						  action="https://apw.simcotech.net/uploadImage"
						  :show-file-list="false"
						  :on-success="handleAvatarSuccess"
						  :before-upload="beforeAvatarUpload">
						  <img v-if="organDetail.organ_img" :src="organDetail.organ_img" class="avatar">
						  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
			  		</div>
			  	</el-col>
			  	<el-col :span="12">
			  		<div class="grid-content bg-purple">背景图片</div>
			  		<div class="grid-content bg-purple">
			  			<el-upload
						  class="avatar-uploader"
						  action="https://apw.simcotech.net/uploadImage"
						  :show-file-list="false"
						  :on-success="handleAvatarBackgroundSuccess"
						  :before-upload="beforeAvatarBackgroundUpload">
						  <img v-if="organDetail.organ_imgbackground" :src="organDetail.organ_imgbackground" class="avatar">
						  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
			  		</div>
			  	</el-col>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="organDetailVisible = false">取消</el-button>
				<el-button type="primary" @click.native="organDetailSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
		<!--顶栏容器-->
		<el-header>
			<el-row >
				<el-col :span="4" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
					{{collapsed?'':sysName}}
				</el-col>
				<el-col :span="16">
					<div class="tools" >
						<!--<i class="el-icon-arrow-left" @click="showrouter"></i>-->
						<!--<el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
						  <el-radio-button :label="false">展开</el-radio-button>
						  <el-radio-button :label="true">收起</el-radio-button>
						</el-radio-group>-->
					</div>
				</el-col>
				<el-col :span="4" class="user">
					<el-dropdown trigger="hover">
						<span class="el-dropdown-link userinfo-inner">{{sysUserName}}</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item  @click.native='organDetailSet'>详情设置</el-dropdown-item>
							<el-dropdown-item  @click.native='passwordVisible'>修改密码</el-dropdown-item>
							<!--<el-dropdown-item >设置</el-dropdown-item>-->
							<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
						</el-dropdown-menu>

					</el-dropdown>
				</el-col>
			</el-row>
		</el-header>
		<el-container>
			<!--侧边栏容器-->
			<!--<el-aside width='230px'>
				<el-menu   :collapse="isCollapse" class="el-menu-vertical-demo" default-active="1" @open="handleopen" @close="handleclose" @select="handleselect" >
					<template v-for="(item,index) in $router.options.routes[2].children" v-if="!item.hidden">
						<el-menu-item :index="index+''" @click="$router.push(item.path)">
							<i :class="item.iconCls"></i>
							<span slot="title" >
								{{item.name}}
							</span>
						</el-menu-item>
					</template>
				</el-menu>
			</el-aside>-->
			<el-aside width='230px'>
				<el-menu :collapse="isCollapse" class="el-menu-vertical-demo" default-active="5" @open="handleopen" @close="handleclose" @select="handleselect" >
					<template v-for="(item,index) in $router.options.routes" v-if="!item.hidden" >
						<!--选项卡-->
						<el-submenu :index="index+''" v-if="!item.leaf" >
							<template slot="title">
								<i :class="item.iconCls"></i>
								{{item.name}}
							</template>
							<el-menu-item v-for="(child,child_idx) in item.children"  :index="index+'-'+child_idx+''" @click="$router.push(child.path)" :key="child.path" v-if="!child.hidden&&(!child.isAdmin||GLOBAL.organ_sysno==GLOBAL.adminSysno.adminOrgan)">
								{{child.name}}
							</el-menu-item>
						</el-submenu>
						<!--直接选项-->
						<el-menu-item v-else v-show="item.name!='机构管理'||GLOBAL.organ_sysno==GLOBAL.adminSysno.adminOrgan" :index="index+''" @click="$router.push(item.path)"  >
							<i :class="item.iconCls"></i>
							<span slot="title" >
								{{item.name}}
							</span>
						</el-menu-item>
					</template>
					<el-menu-item v-show="'可视化看板'"  >
							<i :class="'el-icon-picture'"></i>
							<span slot="title" >
								<a :href="'http://106.14.107.81:8086/?os='+GLOBAL.organ_sysno+'&us='+GLOBAL.organDetail.upper_sysno" style='text-decoration:none;' target="_blank" slot="title" >看板地图</a>
							</span>
					</el-menu-item>
				</el-menu>
			</el-aside>
			<!--主要内容容器-->
			<el-main :class="longMain?'long_main':''">
				<!--<el-row>-->
					<!--<el-col :span="24" class="content-wrapper">-->
					<div class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</div>
					<!--</el-col>-->
				<!--</el-row>-->
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	import util from '../common/js/util'
	import { edit_organUserPassword,setOrganDetail,getOrganDetail} from '../api/api';
	export default {
		data() {
			return {
				organ_sysno:'',
				adminLimted:false,//管理员权限
				sysName:'SIMCO',
				collapsed:false,
				sysUserName: '',
				sysUserAvatar: '',
				isCollapse:false,
				type:'simco',
				longMain:false,
				addLoading: false,
				passwordChangeVisible:false,
				password:{
					passwordOld:'',
					passwordNew:'',
				},
				editLoading: false,
				organDetailVisible:false,
				organDetail:{
					organ_sysno:'',
					name:'',
					shortname:'',
					upper_sysno:'',
					organ_img: '',
					organ_imgbackground:'',
					organ_phone:''
				},
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				}
			}
		},
		methods: {
			onSubmit() {
				console.log('submit!');
			},
			handleopen() {
				console.log('handleopen');
			},
			handleclose(index) {
				console.log(index)

				console.log('handleclose');
			},
			handleselect: function (index, b) {
				if(index=='1-2'){
					this.longMain=true
				}else{
					this.longMain=false
				}
			},
			showrouter:function(){
				console.log(this.$router.options.routes)
			},
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					sessionStorage.removeItem('organ');
					_this.$router.push('/login');
				}).catch(() => {

				});
			},
			admin_limit:function(){
				var that=this
				if(that.GLOBAL.organ_sysno==that.GLOBAL.adminSysno.adminOrgan){
					that.adminLimted=true
				}
			},
			//设置机构详情
			organDetailSet: function () {
				this.organDetailVisible = true;
				console.log(this.GLOBAL.organDetail)
				this.organDetail.organ_sysno=this.GLOBAL.organDetail.organ_sysno
				this.organDetail.name=this.GLOBAL.organDetail.name
				this.organDetail.account=this.GLOBAL.organDetail.account
				this.organDetail.upper_sysno=this.GLOBAL.organDetail.upper_sysno
				this.organDetail.shortname=this.GLOBAL.organDetail.organ_sortname?this.GLOBAL.organDetail.organ_sortname:''
				this.organDetail.organ_phone=this.GLOBAL.organDetail.organ_phone
				this.organDetail.organ_img=this.GLOBAL.organDetail.organ_img?this.GLOBAL.organDetail.organ_img:''
				this.organDetail.organ_imgbackground=this.GLOBAL.organDetail.organ_imgbackground?this.GLOBAL.organDetail.organ_imgbackground:''
			},
			handleAvatarSuccess(res, file) {
		        this.organDetail.organ_img = res.name//URL.createObjectURL(file.raw);
	      	},
	      	handleAvatarBackgroundSuccess(res, file){
	      		this.organDetail.organ_imgbackground = res.name//URL.createObjectURL(file.raw);
	      	},
	      	beforeAvatarUpload(file) {
		      	console.log(file)
		        const isJPG = file.type === 'image/jpeg';
		        const isPNG = file.type === 'image/png';
		        const isLt2M = file.size / 1024 / 1024 < 2;

		        if (!isJPG&&!isPNG) {
		          this.$message.error('上传头像图片只能是 JPG 格式或 PNG 格式!');
		        }
		        if (!isLt2M) {
		          this.$message.error('上传头像图片大小不能超过 2MB!');
		        }
		        return (isJPG||isPNG) && isLt2M;
	      	},
	      	beforeAvatarBackgroundUpload(file){
	      		console.log(file)
		        const isJPG = file.type === 'image/jpeg';
		        const isPNG = file.type === 'image/png';
		        const isLt2M = file.size / 1024 / 1024 < 2;

		        if (!isJPG&&!isPNG) {
		          this.$message.error('上传背景图片只能是 JPG 格式或 PNG 格式!');
		        }
		        if (!isLt2M) {
		          this.$message.error('上传背景图片大小不能超过 2MB!');
		        }
		        return (isJPG||isPNG) && isLt2M;
	      	},
	      	organDetailSubmit: function () {
				this.$confirm('确认修改吗？', '提示', {}).then(() => {
					this.editLoading = true;
					//NProgress.start();
					let para = Object.assign({}, this.organDetail);
					//para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
					setOrganDetail(para).then((res) => {
						this.editLoading = false;
						if(res.data.data.result==1){
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							let para2=Object.assign({},{organ_upper_sysno:this.organDetail.upper_sysno})
							getOrganDetail(para2).then((res)=>{
								console.log(res.data)
								this.GLOBAL.organDetail.name=res.data.name
								this.GLOBAL.organDetail.organ_img=res.data.organ_img
								this.GLOBAL.organDetail.organ_imgbackground=res.data.organ_imgbackground
								this.GLOBAL.organDetail.organ_phone=res.data.organ_phone
								this.GLOBAL.organDetail.organ_sortname=res.data.organ_sortname
								this.GLOBAL.organDetail.power_verification=res.data.power
								this.sysUserName=this.GLOBAL.organDetail.name
							})
						}else if(res.data.data.result==2){
							this.$message({
								message: '修改失败， 数据错误',
								type: 'error'
							});
						}else{
							this.$message({
								message: '修改失败，已有重复数据',
								type: 'error'
							});
						}
						//NProgress.done();
						this.organDetailVisible = false;
					});
				});
			},
			passwordVisible:function(){
				this.passwordChangeVisible=true
				this.password.passwordNew=''
				this.password.passwordOld=''
				console.log(this.passwordChangeVisible)
			},
			passwordChange:function(){
				this.$confirm('确认提交吗？', '提示', {}).then(() => {
					this.addLoading = true;
					let para = {
						passwordNew:this.password.passwordNew,
						passwordOld:this.password.passwordOld,
						organ_sysno:this.GLOBAL.organ_sysno
					}
					console.log(para)
					edit_organUserPassword(para).then((res) => {
						this.addLoading = false;
						if(res.data.data.result==1){
							this.$message({
								message: '提交成功',
								type: 'success'
							});
							this.passwordChangeVisible=false
						}else if(res.data.data.result==3){
							this.$message({
								message: '参数错误',
								type: 'error'
							});
						}else{
							this.$message({
								message: '密码错误',
								type: 'error'
							});
						}
					});
				});
			},
			//折叠导航栏
			collapse:function(){
				console.log(this)
				this.collapsed=!this.collapsed;
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			}
		},
		mounted() {
//			admin_limit()
		},
		created(){
			var user = sessionStorage.getItem('organ');
//			var user = localStorage.getItem('organ');
			if (user) {
				user = JSON.parse(user);
				this.sysUserName = user.name || '';
				this.organ_sysno = user.organ_sysno || '';
				this.GLOBAL.organDetail=user
			}
			this.GLOBAL.organ_sysno=this.organ_sysno
			console.log(this.GLOBAL.organ_sysno)
		}
	}
</script>

<style  slot-scope lang="scss">
	$background-color:#409EFF;
	$color:#fff;
	@mixin whBase($width,$height){
		width:$width;
		height:$height;
	}
	@mixin mpBase($margin,$padding){
		margin:$margin;
		padding:$padding;
	}
	@mixin psBase($position,$top,$left){
		position:$position;
		top:$top;
		left:$left;
	}
	.long_main{
		padding: 1px 0;
	}
	.el-main>.content-wrapper,.el-container{
		height: 100%;
	}
	.el-menu-vertical-demo{
		height: 100%;
	}
	/*基础*/
	.avatar-uploader{
		background: #fff;
		.el-upload[data-v-957c9522] {
		    border: 1px dashed #d9d9d9;
		    border-radius: 6px;
		    cursor: pointer;
		    position: relative;
		    overflow: hidden;
	  	}
  	}
  	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
  	}
  	.headimage .el-upload{
	  		max-width: 178px;
	    	border-radius: 100%;
	    	min-width: 178px;
	  	}
  	.headimage{
  		img{
	  		margin: auto;
	  	}
  	}
  	/*.el-col .bg-purple{
  		line-height: 40px;
  	}*/
  	.avatar-uploader i:hover {
	    	border-color: #409EFF;
	  	}
  	.avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
  	}
  	.avatar {
	    /*width: 178px;*/
	    height: 178px;
	    display: block;
  	}
  	.el-dialog{
  		min-width: 950px;
  	}
 .el-container {
		.el-header {
			@include whBase(auto,10px);
			padding:0;
			background-color:$background-color;
			color:$color;
			.el-row{
				flex-wrap:nowrap;
				display: flex;
			}
			.logo {
				text-align: center;
				height:60px;
				line-height: 60px;
				font-size: 22px;
				padding-left:20px;
				padding-right:20px;
				border-color: rgba(238,241,146,0.3);
				border-right-width: 1px;
				border-right-style: solid;
				img {
					width: 40px;
					float: left;
					margin: 10px 10px 10px 18px;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:230px;
				box-sizing: border-box;
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{
				font-size: 30px;
				padding: 0px 10px;
				width:30px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
			.user{
				display: flex;
				line-height: 60px;
			}
			.el-dropdown{
				color: $color;
				height: 60px;
				overflow: hidden;
			}

		}
		.main {}

	}
</style>



// WEBPACK FOOTER //
// src/components/home.vue